import type { OpportunityRadar } from '@intelimove/contracts';
import { api } from '../api/client';

export const radarApi = {
  list: (limit = 5, offset = 0, signal?: AbortSignal) => api<OpportunityRadar>(`/api/v1/opportunity-radar?limit=${limit}&offset=${offset}`, { signal }),
};
